package org.example.zone360.pages.players_Details.coachesRecommendation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowsRotate
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import kotlinx.coroutines.launch
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.EditSummaryRequest
import org.example.zone360.models.GetSinglePlayerData
import org.example.zone360.pages.dashboard.SectionTitle
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Constants
import org.example.zone360.utils.ToastID
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun CoachRecommendation(breakpoint: Breakpoint,
                        sitePalette: SitePalette,
                        getPlayerInfo: GetSinglePlayerData,
                        toastMessage: (String) -> Unit,
                        summary: String
) {
    val scope = rememberCoroutineScope()
    var hideRefresh by remember { mutableStateOf(false) }
    var isLoading by remember { mutableStateOf(false) }
    LaunchedEffect(getPlayerInfo){
        hideRefresh = getPlayerInfo.latestAssessment.isBlank()
    }

    Box(
        modifier = Modifier
//            .maxHeight(400.px)
            .fillMaxWidth()
            .backgroundColor(sitePalette.modalBackgroundColor.rgb)
            .borderRadius(15.px)
            .overflow(
                overflowY = Overflow.Hidden,
                overflowX = Overflow.Auto
            )
            .boxShadow(
                offsetY = 1.px,
                blurRadius = 3.px,
                color = sitePalette.boxShadowColor.rgb
            )
            .border(1.px, style = LineStyle.Solid, color = sitePalette.coachDetailsBoxBorder.rgb)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
//                .width(if (breakpoint <= Breakpoint.LG) 1360.px else 100.percent)
                .fillMaxHeight()
        ) {
            Box(modifier = Modifier.width(98.8.percent)) {
                Column(
                    modifier = Modifier.fillMaxWidth()
                        .padding(16.px)
                ) {
                    Row (modifier = Modifier.fillMaxWidth().margin(bottom = if (breakpoint < Breakpoint.MD) 0.px else 15.px),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceBetween) {
                        SectionTitle("Coach’s Recommendation", bottom = 0.px)

                        if (!hideRefresh) {
                            if (isLoading) {
                                ProgressIndicator()
                            } else {
//                                FaArrowsRotate(
//                                    modifier = Modifier.color(sitePalette.infoIconColor.rgb)
//                                        .cursor(Cursor.Pointer)
//                                        .onClick {
//                                            scope.launch {
//                                                toastMessage("Feature Under Development")
//                                                showToast(ToastID.SUCCESS)
//                                                try {
//                                                    isLoading = true
//                                                    val request = EditSummaryRequest(
//                                                        text = sessionsData.text,
//                                                        repair_text_before_analysis = true,
//                                                        session_type = sessionsData.sessionType,
//                                                        coach_name = sessionsData.coachName,
//                                                        player_name = sessionsData.playerName,
//                                                        domain_type = sessionsData.domainType,
//                                                        get_summary = true,
//                                                        summary_only = true,
//                                                        edit_only = false,
//                                                        get_insights = false,
//                                                        session_id = sessionsData.sessionId,
//                                                        language = sessionsData.language,
//                                                        organization = AppGlobal.userData.organization
//                                                    )
//                                                    val response = summaryAnalysis(request)
//                                                    summaryText = response.response.summary
//                                                    val update = response.response.summaryRevision
//                                                    if (update >= 2) {
//                                                        hideRefresh = true
//                                                    }
//
//                                                } catch (
//                                                    e: Exception
//                                                ) {
//                                                    toastMessageCall("Failed: ${e.message}")
//                                                } finally {
//                                                    isLoading = false
//                                                }
//                                            }
//
//                                        }, size = IconSize.LG
//                                )
                            }
                        }

                    }
                    FieldTitleTextNormalSimple(
                        text = summary.trim(),
                        fontSize = 15.px,
                        fontFamily = Constants.IBM_FONT,
                        width = 100.percent,
                        marginBottom = 8.px,
                        textAlign = TextAlign.Justify,
                        marginTop = 8.px
                    )
                }
            }
        }
    }
}